/* global newrelic */
import { setState, getState } from '../state';

export const productResultsListener = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('product-results.render-rate', ({ output }) => {
    const {
      requestedProductCount,
      renderedProductCount,
      requestedSponsoredProductCount,
      renderedSponsoredProductCount
    } = output;
    newrelic.addPageAction('ProductResultsProductRenderRate', {
      requestedProductCount,
      renderedProductCount,
      requestedSponsoredProductCount,
      renderedSponsoredProductCount,
      componentName: '@thd-olt-component-react/product-results'
    });
  });
};
